import { render, staticRenderFns } from "./ForumArticleBox.vue?vue&type=template&id=13c65267&scoped=true"
import script from "./ForumArticleBox.vue?vue&type=script&lang=ts"
export * from "./ForumArticleBox.vue?vue&type=script&lang=ts"
import style0 from "./ForumArticleBox.vue?vue&type=style&index=0&id=13c65267&prod&scoped=true&lang=css"
import style1 from "./ForumArticleBox.vue?vue&type=style&index=1&id=13c65267&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c65267",
  null
  
)

export default component.exports